import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../../shared/abstract-boxes';

import { copyInputToClipboard } from './../../shared/helpers';

export function AdEntryPointBoxViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementView.extend({

    template: `
<div class="html-element facebook-ad-box">
  <div class="facebook-ad-content-container">
    <div class="question-text-content-container">
      <div>
        <div class="entrypoint-description-label"></div>
        <div class="entrypoint-description"></div>
      </div>
      <div class="question-edit-container"><span class="glyphicon glyphicon-pencil question-edit"></span></div>
    </div>
    <div class="question-text-content-container">
      <div class="facebook-ad-metadata-label">
        ${services.$translate.instant('parameters/quick_replies/details/facebook_ad/metadata_label')} :
      </div>
      <div class="facebook-ad-metadata-value"></div>
      <div class="ad-id-container">
        ${services.$translate.instant('parameters/quick_replies/details/graph/edit_ad_id_field_label')} : 
        <span class="ad-id"></span>
      </div>
      <div class="receive-control-info-and-copy-container">
        <span class="glyphicon glyphicon-question-sign receive-control-info click-to-messenger-info"></span>
        <span class="glyphicon glyphicon-copy receive-control-copy copy-bot-payload"></span>
      </div>
    </div>
  </div>
</div>
`,

    titleOfInformationPopin: null,
    postbackPayload: null,

    initialize: function () {

      this.model.set("canBeTested", false); // At the moment the backend doesn't handle testing these boxes because it expects the id of the 'next' child and we pass it the id of the box itself

      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);

      // this.$box is initialized by the abstract superclass
      this.$box.find('.receive-control-info').on('click', () => this.showInformationPopin());

      const messages = {
        success: 'parameters/quick_replies/details/facebook_ad/copy_payload_success',
        error: 'parameters/quick_replies/details/facebook_ad/copy_payload_error2'
      };
      this.$box.find('.receive-control-copy').on('click', () => copyInputToClipboard(services, this.model.get('postback_payload'), messages));
      this.$box.find('.question-edit').on('click', () => this.editBox());

      switch (this.model.get('type')) {
        case 'html.ClickToMessengerBox':
          this.titleOfInformationPopin = services.$translate.instant('parameters/quick_replies/details/graph/click_to_messenger_box_title_in_panel');
          break;
        case 'html.SponsoredBzcMessageBox':
          this.titleOfInformationPopin = services.$translate.instant('parameters/quick_replies/details/graph/sponsored_bzc_message_box_title_in_panel');
          break;
        case 'html.LineRichMenuBox':
          this.titleOfInformationPopin = services.$translate.instant('parameters/quick_replies/details/graph/line_rich_menu_box_title_in_panel');
          break;
      }
      if (!this.canHaveOneAdId()) {
        this.$box.find('.ad-id-container').hide();
      }
    },


    canHaveOneAdId: function () {
      return this.model.get('type') === 'html.ClickToMessengerBox';
    },

    updateBox: function () {
      if (this.paper) {
        this.$box.find('.entrypoint-description').text(this.model.get('entrypoint_description'));
        let payload = this.model.get('postback_payload');
        this.$box.find('.facebook-ad-metadata-value').text(payload);
        let adId = this.model.get('ad_id');
        this.$box.find('.ad-id').text(adId);
      }
      joint.shapes.html.AbstractBoxElementView.prototype.updateBox.apply(this, arguments);
    },


    heightOfHTMLContent: function () {
      return this.$box.find('.facebook-ad-content-container').outerHeight();
    },


    /**
     * Event handler that shows a modal describing what the bot payload is for
     * and what to do with it
     */
    showInformationPopin: function () {
      services.$uibModal.open({
        animation: true,
        template: require('./facebookAd.modal.html'),
        controller: 'facebookAdModalController',
        resolve: {
          controllerParams: {
            postbackPayload: this.model.get('postback_payload'),
            titleOfInformationPopin: this.titleOfInformationPopin,
            facebookAdType: this.model.get('type')
          }
        }
      });
    },


    editBox: function () {
      const currentAdIds = this.model.getEmbeddedCells()
        .filter(box => box.get('type') === 'html.FacebookAdId')
        .map(box => box.get('elementData').adId);
      services.$mdDialog.show({
        controller: 'editAdBoxController',
        template: require('./editAdBox.modal.html'),
        locals: {
          controllerParams: {
            entrypointDescription: this.model.get('entrypoint_description'),
            canHaveAdIds: (this.canHaveAdIds && this.canHaveAdIds()) || false,
            canHaveOneAdId: this.canHaveOneAdId(),
            adId: this.canHaveOneAdId() ? this.model.get('ad_id') : null,
            currentAdIds: (this.canHaveAdIds && this.canHaveAdIds()) ? currentAdIds : null,
          }
        }
      }).then(modalResult => {
        if (this.canHaveOneAdId()) {
          this.model.set('ad_id', modalResult.adId);
        }
        if (this.canHaveAdIds && this.canHaveAdIds()) {
          this.updateExits(modalResult.newAdIds);
        }
        this.model.set('entrypoint_description', modalResult.entrypointDescription);
        this.resizeBox();
        callbacks.updateSerializedGraph(this.model.graph);
      });
    },


    updateExits: function (newAdIds) {
      const box = this.model;
      const children = box.getEmbeddedCells();
      const currentAdIds = children.map(child => child.get('elementData').adId);
      children.forEach(child => box.unembed(child));
      const childrenToBeRemoved = children.filter(child => !newAdIds.includes(child.get('elementData').adId));
      childrenToBeRemoved.forEach(child => child.remove());
      const numberOfNewChildren = newAdIds.length - (children.length - childrenToBeRemoved.length);
      services.QuickRepliesFactory.createUniqueIds(context.companyId, context.site.id, context.scenarioId, numberOfNewChildren)
        .then(response => {
          const uniqueIds = response.data.map(element => element.id);
          let uniqueIdsIndex = 0;
          for (const adId of newAdIds) {
            if (currentAdIds.includes(adId)) {
              box.embed(children.find(child => child.get('elementData').adId === adId));
            } else {
              box.graph.addCell(this.createFacebookAdId(uniqueIds[uniqueIdsIndex++], TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE, { adId }));
            }
          }
          this.resizeBox();
          callbacks.updateSerializedGraph(this.model.graph);
        },
          services.AlertingFactory.httpErrorHandler());
    },



    createFacebookAdId: function (id, position, size, elementData) {
      const exit = new joint.shapes.html.FacebookAdId({ id, position, size, elementData });
      this.model.embed(exit);
      return exit;
    },

  });
}